export enum IncidentTypes {
  TRAFFIC_INCIDENT = 'zdarzenie drogowe',
  ABUSE = 'znęcanie się',
  STRAY_AMIMAL = 'bezpańskie zwierze',
  OTHER = 'inne',
}
